export default __webpack_public_path__ + "7c52bffb5578a22be5125165a7ffebdb.png";